import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from 'components/FormHelper/AddressInput/AddressInput';
import { InputFieldRenderGuard } from 'components/FormHelper/InputFieldRenderGuard';
import { InputRow } from 'components/FormHelper/InputRow';

import { FieldInput } from './FieldInput';

export const SectionContent = ({
  section,
  formik,
  values,
  initialValues,
  comboBoxOptions,
  evaluateConditionOptions,
}) => {
  const isAddressDisabled = !values.companyCountry;

  const renderFields = (fields, disabled = false) => (
    <InputRow>
      {fields?.map((field) => (
        <InputFieldRenderGuard
          key={field.name}
          field={field}
          evaluateConditionOptions={evaluateConditionOptions}>
          <FieldInput
            field={field}
            formik={formik}
            values={values}
            initialValues={initialValues}
            comboBoxOptions={comboBoxOptions}
            evaluateConditionOptions={evaluateConditionOptions}
            disabled={disabled}
          />
        </InputFieldRenderGuard>
      ))}
    </InputRow>
  );

  const countryField = section.fields?.find((f) => f.name === 'companyCountry');
  const otherFields = section.fields?.filter((f) => f.name !== 'companyCountry');

  if (countryField) {
    const countryRow = (
      <InputRow>
        <FieldInput
          field={countryField}
          formik={formik}
          values={values}
          initialValues={initialValues}
          comboBoxOptions={comboBoxOptions}
          evaluateConditionOptions={evaluateConditionOptions}
        />
      </InputRow>
    );

    if (section.id === 'companyAddress') {
      return (
        <>
          {countryRow}
          {values.companyCountry === 'DE' ? (
            <AddressInput formik={formik} />
          ) : (
            renderFields(otherFields, isAddressDisabled)
          )}
        </>
      );
    }

    return (
      <>
        {countryRow}
        {renderFields(otherFields)}
      </>
    );
  }

  return renderFields(section.fields);
};

SectionContent.propTypes = {
  section: PropTypes.object.isRequired,
  formik: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  comboBoxOptions: PropTypes.object.isRequired,
  evaluateConditionOptions: PropTypes.object.isRequired,
};
